/**
 * Pirate Vapes — High-Performance Native Theme Interactivity
 */

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initWishlistDrawer();
  initCartDrawer();
  initCountdownTimer();
  initWishlistToggle();
  initAjaxAddToCart();
});

/* ── Money Formatter Helper ────────────────────────────────────────────────── */
function formatMoney(cents) {
  if (cents === null || cents === undefined) return '£0';
  if (typeof cents === 'string') return cents;
  const rupees = Math.floor(cents / 100);
  return '£' + rupees.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* ── 1. Mobile Menu ───────────────────────────────────────────────────────── */
function initMobileMenu() {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-menu-drawer]');
  const closeBtns = document.querySelectorAll('[data-menu-close]');

  if (!toggle || !drawer) return;

  toggle.addEventListener('click', () => {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });
}

/* ── 2. Wishlist Drawer & LocalStorage Manager ───────────────────────────── */
function getWishlist() {
  try {
    const raw = localStorage.getItem('pv_wishlist');
    const parsed = raw ? JSON.parse(raw) : [];
    // Normalize to objects
    return parsed.map(item => {
      if (typeof item === 'string' || typeof item === 'number') {
        return { id: String(item), title: 'Saved Product', price: '', image: '', variant_id: '', url: '#' };
      }
      return item;
    });
  } catch (e) {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem('pv_wishlist', JSON.stringify(items));
  updateWishlistUI();

  // Wishlist Page Delegation
  const wishlistPageGrid = document.getElementById('WishlistPageGrid');
  if (wishlistPageGrid) {
    wishlistPageGrid.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-wishlist-add-cart]');
      if (addBtn) {
        const variantId = addBtn.dataset.wishlistAddCart;
        if (!variantId) return;

        addBtn.disabled = true;
        const originalHTML = addBtn.innerHTML;
        addBtn.innerHTML = 'Adding...';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(() => {
          addBtn.innerHTML = 'Added!'; addBtn.classList.add('is-added');
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.innerHTML = originalHTML; addBtn.classList.remove('is-added');
          }, 1500);

          fetchAndRenderCart(true);
        })
        .catch(err => {
          console.error(err);
          addBtn.disabled = false;
          addBtn.innerHTML = originalHTML; addBtn.classList.remove('is-added');
        });
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        const idToRemove = removeBtn.dataset.wishlistRemove;
        let wishlist = getWishlist();
        wishlist = wishlist.filter(i => String(i.id) !== String(idToRemove));
        saveWishlist(wishlist);
      }
    });
  }

}

function updateWishlistUI() {
  const wishlist = getWishlist();
  
  // Update all wishlist count badges
  const countBadges = document.querySelectorAll('[data-wishlist-count], [data-wishlist-drawer-count]');
  countBadges.forEach(badge => {
    badge.textContent = wishlist.length;
  });

  // Highlight heart buttons on page
  const wishlistBtns = document.querySelectorAll('.product-card__wishlist');
  wishlistBtns.forEach(btn => {
    const pId = btn.dataset.productId;
    if (pId && wishlist.some(i => String(i.id) === String(pId))) {
      btn.classList.add('is-active');
      btn.style.color = '#054bff';
    } else {
      btn.classList.remove('is-active');
      btn.style.color = '#CCCCCC';
    }
  });

  // Re-render drawer content if container exists
  renderWishlistDrawer();
  renderWishlistPage();
}


function renderWishlistPage() {
  const container = document.getElementById('WishlistPageGrid');
  if (!container) return;

  const wishlist = getWishlist();

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; padding: 40px 0;">
        <h3 style="font-size:18px; margin-bottom:8px;">Your wishlist is currently empty.</h3>
        <p style="color:#666; margin-bottom: 24px;">Find something you love and save it here.</p>
        <a href="/collections/all" class="btn btn-accent" style="display:inline-block; padding: 12px 24px; text-decoration:none; color:#fff; border-radius:0;">Continue Shopping</a>
      </div>
    `;
    return;
  }

  let html = '';
  wishlist.forEach(item => {
    const imgMarkup = item.image 
      ? `<img src="${item.image}" alt="${item.title}">`
      : `<div style="height:180px; display:flex; align-items:center; justify-content:center; background:#f9f9f9; margin-bottom:16px; border-radius:0;"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>`;

    html += `
      <div class="wishlist-page-item" data-wishlist-id="${item.id}">
        <button type="button" class="remove-btn" data-wishlist-remove="${item.id}" aria-label="Remove item">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <a href="${item.url || '#'}" style="text-decoration:none;">
          ${imgMarkup}
          <h4>${item.title || 'Product'}</h4>
        </a>
        <div class="price">${item.price || ''}</div>
        ${item.variant_id ? `
          <button type="button" class="btn btn-accent" data-wishlist-add-cart="${item.variant_id}" style="background:#111; color:#fff; border:none;">
            Add to Bag
          </button>
        ` : ''}
      </div>
    `;
  });

  container.innerHTML = html;
}

function renderWishlistDrawer() {
  const container = document.querySelector('[data-wishlist-items-container]');
  if (!container) return;

  const wishlist = getWishlist();

  if (wishlist.length === 0) {
    container.innerHTML = `
      <div class="drawer__empty-state">
        <div class="empty-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.78-8.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div>
        <h3>Your wishlist is empty</h3>
        <p>Save items you love to find them easily later!</p>
        <a href="/collections/all" class="btn btn-accent btn-full" style="margin-top: 16px;">Explore Products</a>
      </div>
    `;
    return;
  }

  let html = '';
  wishlist.forEach(item => {
    const imgMarkup = item.image 
      ? `<img src="${item.image}" alt="${item.title}" class="wishlist-drawer-item__image">`
      : `<span style="font-size:24px;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span>`;

    html += `
      <div class="wishlist-drawer-item" data-wishlist-id="${item.id}">
        <a href="${item.url || '#'}" class="wishlist-drawer-item__image-wrap">
          ${imgMarkup}
        </a>
        <div class="wishlist-drawer-item__info">
          <a href="${item.url || '#'}" class="wishlist-drawer-item__title">${item.title || 'Product'}</a>
          <div class="wishlist-drawer-item__price">${item.price || ''}</div>
          <div class="wishlist-drawer-item__actions">
            ${item.variant_id ? `
              <button type="button" class="btn btn-accent wishlist-drawer-item__add-btn" data-wishlist-add-cart="${item.variant_id}">
                Add to Bag
              </button>
            ` : ''}
            <button type="button" class="wishlist-drawer-item__remove-btn" data-wishlist-remove="${item.id}">
              Remove
            </button>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
}

function initWishlistDrawer() {
  const triggers = document.querySelectorAll('[data-wishlist-drawer-toggle]');
  const drawer = document.querySelector('[data-wishlist-drawer]');
  const closeBtns = document.querySelectorAll('[data-wishlist-drawer-close]');

  if (drawer) {
    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        renderWishlistDrawer();
  renderWishlistPage();
      });
    });

    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Wishlist Drawer Delegation (Add to Bag & Remove)
    drawer.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-wishlist-add-cart]');
      if (addBtn) {
        const variantId = addBtn.dataset.wishlistAddCart;
        if (!variantId) return;

        addBtn.disabled = true;
        addBtn.innerHTML = 'Adding...';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(() => {
          addBtn.textContent = '✓ Added!';
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Bag';
          }, 1500);

          // Close wishlist drawer and open cart drawer
          drawer.classList.remove('is-open');
          fetchAndRenderCart(true);
        })
        .catch(err => {
          console.error('Wishlist add to cart error:', err);
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Bag';
        });
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        const idToRemove = removeBtn.dataset.wishlistRemove;
        let wishlist = getWishlist();
        wishlist = wishlist.filter(i => String(i.id) !== String(idToRemove));
        saveWishlist(wishlist);
      }
    });
  }

  updateWishlistUI();

  // Wishlist Page Delegation
  const wishlistPageGrid = document.getElementById('WishlistPageGrid');
  if (wishlistPageGrid) {
    wishlistPageGrid.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-wishlist-add-cart]');
      if (addBtn) {
        const variantId = addBtn.dataset.wishlistAddCart;
        if (!variantId) return;

        addBtn.disabled = true;
        const originalHTML = addBtn.innerHTML;
        addBtn.innerHTML = 'Adding...';

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(() => {
          addBtn.innerHTML = 'Added!'; addBtn.classList.add('is-added');
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.innerHTML = originalHTML; addBtn.classList.remove('is-added');
          }, 1500);

          fetchAndRenderCart(true);
        })
        .catch(err => {
          console.error(err);
          addBtn.disabled = false;
          addBtn.innerHTML = originalHTML; addBtn.classList.remove('is-added');
        });
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        const idToRemove = removeBtn.dataset.wishlistRemove;
        let wishlist = getWishlist();
        wishlist = wishlist.filter(i => String(i.id) !== String(idToRemove));
        saveWishlist(wishlist);
      }
    });
  }

}

/* ── 3. Wishlist Heart Buttons Handler ────────────────────────────────────── */
function initWishlistToggle() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-card__wishlist');
    if (!btn) return;

    e.preventDefault();

    const id = btn.dataset.productId;
    if (!id) return;

    const title = btn.dataset.productTitle || 'Product';
    const price = btn.dataset.productPrice || '';
    const image = btn.dataset.productImage || '';
    const variant_id = btn.dataset.variantId || '';
    const url = btn.dataset.productUrl || '#';

    let wishlist = getWishlist();
    const existsIndex = wishlist.findIndex(i => String(i.id) === String(id));

    if (existsIndex > -1) {
      wishlist.splice(existsIndex, 1);
    } else {
      wishlist.push({ id, title, price, image, variant_id, url });
    }

    saveWishlist(wishlist);
  });
}

/* ── 4. Slide-out Cart Drawer & Cart Page Interactivity ───────────────────── */
function initCartDrawer() {
  const triggers = document.querySelectorAll('[data-cart-drawer-toggle]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const closeBtns = document.querySelectorAll('[data-cart-drawer-close]');

  if (drawer) {
    triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        fetchAndRenderCart(false);
      });
    });

    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // Global event delegation for Cart Quantity +/- and Remove buttons
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      const change = parseInt(qtyBtn.dataset.cartQtyChange, 10);
      const key = qtyBtn.dataset.key;
      const currentQty = parseInt(qtyBtn.dataset.qty, 10);
      const newQty = Math.max(0, currentQty + change);
      updateCartLineItem(key, newQty);
      return;
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.dataset.key;
      updateCartLineItem(key, 0);
      return;
    }
  });

  // Initial cart fetch on page load to hydrate UI
  fetchAndRenderCart(false);
}

function fetchAndRenderCart(openDrawer = false) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartUI(cart);
      if (openDrawer) {
        const drawer = document.querySelector('[data-cart-drawer]');
        if (drawer) {
          drawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      }
    })
    .catch(err => console.error('Cart fetch error:', err));
}

function updateCartLineItem(key, newQuantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: key, quantity: newQuantity })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartUI(cart);
  })
  .catch(err => console.error('Cart line update error:', err));
}

function updateCartUI(cart) {
  // 1. Update Cart Count Badges
  const countBadges = document.querySelectorAll('[data-cart-count]');
  countBadges.forEach(b => {
    if (b.classList.contains('cart-page-count')) {
      b.textContent = `${cart.item_count} items`;
    } else {
      b.textContent = cart.item_count;
    }
  });

  // 2. Update Free Shipping Progress Bar (Threshold: £30 / 3000 cents)
  const threshold = 3000;
  const currentTotal = cart.total_price || 0;
  const progressFillElements = document.querySelectorAll('[data-free-shipping-fill]');
  const progressTextElements = document.querySelectorAll('[data-free-shipping-text]');

  const percentage = Math.min(100, Math.round((currentTotal / threshold) * 100));

  progressFillElements.forEach(fill => {
    fill.style.width = `${percentage}%`;
  });

  progressTextElements.forEach(textEl => {
    if (currentTotal >= threshold) {
      textEl.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> <strong>Free Shipping unlocked!</strong>';
    } else {
      const remainingCents = threshold - currentTotal;
      const formattedRemaining = formatMoney(remainingCents);
      textEl.innerHTML = `Add <strong>${formattedRemaining}</strong> more to get <strong>Free Shipping</strong>`;
    }
  });

  // 3. Update Subtotal Displays
  const subtotalElements = document.querySelectorAll('[data-cart-subtotal]');
  const formattedSubtotal = formatMoney(cart.total_price);
  subtotalElements.forEach(el => el.textContent = formattedSubtotal);

  // 4. Update Cart Drawer Body Items
  const drawerContainer = document.querySelector('[data-cart-drawer-items]');
  if (drawerContainer) {
    if (cart.item_count === 0) {
      drawerContainer.innerHTML = `
        <div class="drawer__empty-state">
          <div class="empty-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></div>
          <h3>Your cart is empty</h3>
          <p>Explore our wide range of vapes, e-liquids, and coils!</p>
          <a href="/collections/all" class="btn btn-accent btn-full" style="margin-top: 16px;">Shop Now</a>
        </div>
      `;
    } else {
      let html = '';
      cart.items.forEach(item => {
        const itemImg = item.image 
          ? `<img src="${item.image}" alt="${item.title}" class="cart-drawer-item__image">`
          : `<div class="placeholder-img"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>`;

        const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="cart-drawer-item__variant">${item.variant_title}</div>`
          : '';

        const formattedPrice = formatMoney(item.final_price);

        html += `
          <div class="cart-drawer-item" data-cart-item-key="${item.key}">
            <a href="${item.url}" class="cart-drawer-item__image-wrap">
              ${itemImg}
            </a>
            <div class="cart-drawer-item__info">
              <a href="${item.url}" class="cart-drawer-item__title">${item.product_title || item.title}</a>
              ${variantHtml}
              <div class="cart-drawer-item__price">${formattedPrice}</div>
              
              <div class="cart-drawer-item__actions">
                <div class="quantity-stepper mini-stepper">
                  <button type="button" class="qty-btn minus" data-cart-qty-change="-1" data-key="${item.key}" data-qty="${item.quantity}">-</button>
                  <span class="qty-val">${item.quantity}</span>
                  <button type="button" class="qty-btn plus" data-cart-qty-change="1" data-key="${item.key}" data-qty="${item.quantity}">+</button>
                </div>

                <button type="button" class="cart-drawer-item__remove" data-cart-remove data-key="${item.key}" aria-label="Remove item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
                  Remove
                </button>
              </div>
            </div>
          </div>
        `;
      });
      drawerContainer.innerHTML = html;
    }
  }

  // 5. Update Cart Page Items Column if on Cart Page
  const cartPageItemsContainer = document.querySelector('[data-cart-page-items]');
  if (cartPageItemsContainer) {
    if (cart.item_count === 0) {
      cartPageItemsContainer.innerHTML = `
        <div class="cart-page-empty">
          <div class="empty-icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></div>
          <h2>Your cart is currently empty</h2>
          <p>Before you check out, you must add some products to your shopping cart.</p>
          <a href="/collections/all" class="btn btn-accent btn-large" style="margin-top: 20px;">Explore Products</a>
        </div>
      `;
      const summaryCol = document.querySelector('[data-cart-summary-col]');
      if (summaryCol) summaryCol.style.display = 'none';
    } else {
      let rowsHtml = `
        <div class="cart-items-table">
          <div class="cart-table-header desktop-only">
            <span class="col-product">Product</span>
            <span class="col-price">Price</span>
            <span class="col-quantity">Quantity</span>
            <span class="col-total">Total</span>
          </div>
      `;

      cart.items.forEach(item => {
        const itemImg = item.image 
          ? `<img src="${item.image}" alt="${item.title}" class="cart-item-img">`
          : `<div class="placeholder-img"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>`;

        const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? `<div class="cart-item-variant">${item.variant_title}</div>`
          : '';

        const unitPrice = formatMoney(item.final_price);
        const lineTotal = formatMoney(item.final_line_price);

        rowsHtml += `
          <div class="cart-item-row" data-cart-item-key="${item.key}">
            <div class="cart-item-col col-product">
              <a href="${item.url}" class="cart-item-img-wrap">
                ${itemImg}
              </a>
              <div class="cart-item-details">
                <a href="${item.url}" class="cart-item-title">${item.product_title || item.title}</a>
                ${variantHtml}
                <button type="button" class="cart-item-remove-btn" data-cart-remove data-key="${item.key}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  Remove
                </button>
              </div>
            </div>

            <div class="cart-item-col col-price">
              <span class="mobile-label mobile-only">Price:</span>
              <span class="cart-item-unit-price">${unitPrice}</span>
            </div>

            <div class="cart-item-col col-quantity">
              <span class="mobile-label mobile-only">Quantity:</span>
              <div class="quantity-stepper">
                <button type="button" class="qty-btn minus" data-cart-qty-change="-1" data-key="${item.key}" data-qty="${item.quantity}">-</button>
                <span class="qty-val">${item.quantity}</span>
                <button type="button" class="qty-btn plus" data-cart-qty-change="1" data-key="${item.key}" data-qty="${item.quantity}">+</button>
              </div>
            </div>

            <div class="cart-item-col col-total">
              <span class="mobile-label mobile-only">Total:</span>
              <span class="cart-item-line-price">${lineTotal}</span>
            </div>
          </div>
        `;
      });

      rowsHtml += `</div>`;
      cartPageItemsContainer.innerHTML = rowsHtml;
      const summaryCol = document.querySelector('[data-cart-summary-col]');
      if (summaryCol) summaryCol.style.display = '';
    }
  }
}

/* ── 5. AJAX Add to Bag (Intercept Product Form Submissions) ────────────── */
function initAjaxAddToCart() {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      e.preventDefault();

      const submitBtn = form.querySelector('button[type="submit"]');
      const originalHTML = submitBtn ? submitBtn.innerHTML : 'Add to Bag';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Adding...';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(res => res.json())
      .then(item => {
        if (submitBtn) {
          submitBtn.innerHTML = '✓ Added!';
          submitBtn.classList.add('is-added');
          setTimeout(() => {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalHTML;
            submitBtn.classList.remove('is-added');
          }, 1500);
        }
        // Fetch updated cart and open Cart Drawer
        fetchAndRenderCart(true);
      })
      .catch(err => {
        console.error('Cart add error:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalHTML;
        }
      });
    }
  });
}

/* ── 6. Live Countdown Timer for Best Deals ───────────────────────────────── */
function initCountdownTimer() {
  const timerContainer = document.querySelector('.countdown-badge');
  if (!timerContainer) return;

  const targetTime = new Date().getTime() + (48 * 60 * 60 * 1000);

  function updateTimer() {
    const now = new Date().getTime();
    const difference = targetTime - now;

    if (difference <= 0) return;

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    const boxes = timerContainer.querySelectorAll('.countdown-box');
    if (boxes.length >= 4) {
      boxes[0].textContent = String(days).padStart(2, '0');
      boxes[1].textContent = String(hours).padStart(2, '0');
      boxes[2].textContent = String(minutes).padStart(2, '0');
      boxes[3].textContent = String(seconds).padStart(2, '0');
    }
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

/* ── 7. Variant Selection Logic ───────────────────────────────────────────── */
function initVariantSelection() {
  const variantOptions = document.querySelectorAll('.variant-option');
  if (variantOptions.length === 0) return;

  const idInput = document.querySelector('input[name="id"]');
  const form = document.querySelector('.product-form');
  const priceDisplay = document.querySelector('.product-details__price');
  const addBtn = document.querySelector('.pdp-add-btn');

  // Find the JSON data block (last script added)
  const scriptTag = document.querySelector('script[id^="ProductData-"]');
  if (!scriptTag) return;

  let variants = [];
  try {
    variants = JSON.parse(scriptTag.textContent);
  } catch(e) {
    console.error("Could not parse variants JSON");
    return;
  }

  variantOptions.forEach(optionGroup => {
    const hiddenInput = optionGroup.querySelector('input[type="hidden"]');
    const pills = optionGroup.querySelectorAll('.variant-pill');

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update active class
        pills.forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        
        // Update hidden input for this specific option
        hiddenInput.value = pill.dataset.value;

        // Collect all currently selected options
        const currentOptions = Array.from(document.querySelectorAll('.variant-option input[type="hidden"]')).map(input => input.value);
        
        // Find matching variant
        const matchedVariant = variants.find(variant => {
          return currentOptions.every((val, index) => {
            return variant['option' + (index + 1)] === val;
          });
        });

        if (matchedVariant) {
          idInput.value = matchedVariant.id;
          
          if (matchedVariant.available) {
            addBtn.disabled = false;
            addBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add to Bag`;
            if (priceDisplay) priceDisplay.innerHTML = formatMoney(matchedVariant.price);
          } else {
            addBtn.disabled = true;
            addBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Sold Out`;
          }

          // Optional: Update URL with variant query param
          const url = new URL(window.location);
          url.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', url);
        } else {
          // Combination not available
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initVariantSelection);

/* ── 8. Collection Sidebar Filtering ───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  const filterForm = document.getElementById('CollectionFiltersForm');
  if (filterForm) {
    const inputs = filterForm.querySelectorAll('input[type="checkbox"], input[type="number"]');
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        filterForm.submit(); // Auto-submit on change for premium feel
      });
    });
  }
});

/* ── 9. Sticky Header Height Tracker ─────────────────────────────────────── */
function initStickyHeaderTracker() {
  function updateHeaderHeight() {
    const header = document.querySelector('.header-sticky-wrapper') || 
                   document.querySelector('.shopify-section-group-header-group') ||
                   document.querySelector('.main-header');
    if (header) {
      const h = header.offsetHeight;
      if (h > 0) {
        document.documentElement.style.setProperty('--header-height', h + 'px');
      }
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  window.addEventListener('scroll', updateHeaderHeight, { passive: true });
  if (window.ResizeObserver) {
    const headerElem = document.querySelector('.header-sticky-wrapper') || document.querySelector('.shopify-section-group-header-group');
    if (headerElem) new ResizeObserver(updateHeaderHeight).observe(headerElem);
  }
}
document.addEventListener('DOMContentLoaded', initStickyHeaderTracker);

